import { useCallback } from "react";
import { useTrackedSessionStorage } from "./use-tracked-browser-storage";

/**
 * Hook for managing webpage channel selection with sessionStorage persistence.
 *
 * Features:
 * - Persists channel selection in sessionStorage (tab-specific)
 * - Follows standardized key naming: webpages::explorer::selected-channel
 * - Defaults to "all" channels when no selection is stored
 */
export function useWebpageChannelSelection(): {
  selectedChannelId: string;
  setSelectedChannelId: (channelId: string) => void;
} {
  // Store selected channel in sessionStorage with standardized key
  const [selectedChannelId, setSelectedChannelIdStorage] =
    useTrackedSessionStorage<string>(
      "webpages::explorer::selected-channel",
      "all", // Default to "all" channels
    );

  // Provide a clean interface for setting the channel ID
  const setSelectedChannelId = useCallback(
    (channelId: string) => {
      setSelectedChannelIdStorage(channelId);
    },
    [setSelectedChannelIdStorage],
  );

  return {
    selectedChannelId: selectedChannelId || "all", // Fallback to "all" if null/undefined
    setSelectedChannelId,
  };
}
